import React from 'react'
import Mousetrap from 'mousetrap'

export interface UseKeyBindingProps {
  bindShortcut(keys: string, callback: () => void): void
  unbindShortcut(keys: string): void
  unbindAllShortcuts(): void
}

export function useKeyBindings(): UseKeyBindingProps {
  const boundKeys = React.useRef<string[]>([])

  function bindShortcut(keys: string, callback: () => void) {
    Mousetrap.bind(keys, callback)

    boundKeys.current.push(keys)
  }

  function unbindShortcut(keys: string) {
    const index = boundKeys.current.indexOf(keys)

    if (index > -1) {
      boundKeys.current.splice(index, 1)

      Mousetrap.unbind(keys)
    }
  }

  function unbindAllShortcuts() {
    if (boundKeys.current.length < 1) {
      return
    }

    boundKeys.current.forEach(keys => {
      Mousetrap.unbind(keys)
    })

    boundKeys.current = []
  }

  React.useEffect(() => {
    return () => unbindAllShortcuts()
  }, [])

  return {
    bindShortcut,
    unbindShortcut,
    unbindAllShortcuts
  }
}
